import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { getEleve, getPhoto, unlinkSupportEleve } from './eleve.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const EleveUnlinkSupportModal = (props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const eleve = useAppSelector(state => state.eleve.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const id_ = props.match.params.id;
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getEleve(props.match.params.id));
    dispatch(getPhoto(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/eleve/${currentEcole && currentEcole.id}/${props.match.params.anneeScolaireId}/${id_}/details`);
  };

  const confirmUnlink = event => {
    const entity = {
      id: props.match.params.id,
    };
    dispatch(unlinkSupportEleve(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {eleve.id !== null && (
        <Modal
          title="Dissocier le support de l'élève"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmUnlink}>
              Dissocier
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Etes-vous certain de vouloir dissocier ce support de l&apos;élève {eleve.firstName} {eleve.lastName} ?
        </Modal>
      )}
    </>
  );
};

export default EleveUnlinkSupportModal;
